// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import UserImage from 'app/common/react/components/common/UserImage/UserImage';
import { type Dispatch } from 'redux';
import { Box, Button } from 'gestalt';
import { follow, unfollow } from 'app/common/redux/actions/user/follow';
import { track, type TrackingData } from 'app/common/lib/react/analytics';

type State = {
  isFollowing: boolean,
};

export type UserType = {
  explicitly_followed_by_me?: boolean,
  full_name: string,
  id: string,
  image_key?: string,
  image_medium_url?: string,
  image_small_url?: string,
  username: string,
  email?: string,
};

export type UserPropType = {
  className?: string,
  follow: (id: string) => void,
  isSelf?: boolean,
  logData?: TrackingData,
  showFollow?: boolean,
  showName?: boolean,
  size: 'medium' | 'smallerMedium' | 'small',
  subtitle: string,
  title?: string,
  unfollow: (id: string) => void,
  user: UserType,
  viewType: 'thumb',
};

export class User extends Component<UserPropType, State> {
  static defaultProps = {
    followedByMe: false,
    showFollow: false,
    showName: false,
    size: 'small',
    subtitle: '',
    viewType: 'thumb',
  };

  state: State = {
    isFollowing: this.props.user.explicitly_followed_by_me || false,
  };

  handleFollowClick = () => {
    const { follow, unfollow, user } = this.props;
    const { isFollowing } = this.state;

    if (isFollowing) {
      unfollow(user.id);
      this.setState({ isFollowing: false });
    } else {
      follow(user.id);
      this.setState({ isFollowing: true });
    }

    if (this.props.logData) {
      track(PCONST.thrift.EventType.CLICK, this.props.logData);
    }
  };

  renderFollowButton() {
    const { isFollowing } = this.state;
    const { isSelf } = this.props;
    const text = isFollowing ? i18n._('Unfollow') : i18n._('Follow');

    if (isSelf) {
      return (
        <Button
          inline
          disabled
          text={i18n._("That's you!", "Text describing that the person's avatar is you")}
        />
      );
    }

    return (
      <Button
        color={isFollowing ? 'gray' : 'red'}
        inline
        onClick={this.handleFollowClick}
        text={text}
      />
    );
  }

  render() {
    const { className, showName, showFollow, size, subtitle, title, user = {} } = this.props;

    const { full_name, username } = user;

    const src = user.image_key || user.image_medium_url || user.image_small_url;

    return (
      <div className={cx('Module', 'User', 'hasText', 'thumb', size, className)}>
        <Box alignItems="center" direction="row" display="flex" marginStart={-1} marginEnd={-1}>
          <Box flex="grow" paddingX={1}>
            <NavigateLink className="profileSource" to={`/${username}/`}>
              <div className="thumbImageWrapper">
                <UserImage fullName={user.full_name} imageSrc={src} />
              </div>
              {title && <h3 className="title">{title}</h3>}
              {showName && <h4 className="fullname">{full_name}</h4>}
              {subtitle && <div className="subtitle">{subtitle}</div>}
            </NavigateLink>
          </Box>
          {showFollow && <Box paddingX={1}>{this.renderFollowButton()}</Box>}
        </Box>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  follow: (id) => dispatch(follow(id)),
  unfollow: (id) => dispatch(unfollow(id)),
});

export default // $FlowFixMe: add connect<Props, OwnProps, , , _, _>() typing to remove this error
connect(
  null,
  mapDispatchToProps,
)(User);
